import React from 'react';
import { ThemeProvider } from 'styled-components';
import theme from '../core/theme';

function withThemeHoC(Component) {
  const withTheme = props => (
    <ThemeProvider theme={theme}>
      <Component {...props} />
    </ThemeProvider>
  );

  return withTheme;
}

export default withThemeHoC;
